import { useState } from 'react';
import { observable } from 'mobx';

import { useResource } from 'app/common/api';
import { IUserProfileStore } from 'app/railways/domains/profile/core';
import { TUserProfile } from 'app/railways/domains/profile/core/user-profile';

import { IWratableAuthState } from '../../core';
import { getProfile } from '../../requests';

type AuthStatuses = 'idle' | 'loading' | 'granted' | 'error' | 'unauthorized';

type UseAuthCheckParams = {
  userProfileStore: IUserProfileStore;
  authStatusStore: IWratableAuthState;
};
export const useAuthCheck = ({
  userProfileStore,
  authStatusStore,
}: UseAuthCheckParams) => {
  const [status] = useState(() => observable.box<AuthStatuses>('idle'));
  const [error] = useState(() => observable.box<null | string>(null));

  const profileResource = useResource<void, TUserProfile>({
    request: getProfile,
    onDone: (user) => {
      userProfileStore.setProfile(user);

      status.set('granted');
      authStatusStore.allowAccess();
    },
    onAuthRequired() {
      authStatusStore.denyAccess();
      status.set('unauthorized');
    },
    onFail: (errorData) => {
      console.log({ errorData });
      error.set(errorData.message);
      status.set('error');
    },
  });

  return { fetchProfile: () => profileResource.send(), status, error };
};
